/**
 * Client-side RBAC helpers.
 *
 * These mirror the server-side helpers in `dashboard/server/services/rbac.ts`
 * but operate on the string role values exposed by the auth context / session.
 */

/** Returns true when the user has admin-level access (org admin, owner, or platform admin). */
export function isAdmin(
  orgRole: string | null,
  globalRole: string | null,
): boolean {
  if (globalRole === "admin") {
    return true;
  }
  return orgRole === "admin" || orgRole === "owner";
}
